import React, { useState, useEffect } from "react";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { useNavigate, useParams, Link } from "react-router-dom";
import { months } from "moment";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
const MANAGER_ID = 1;

const getToday = () => {
  const date = new Date();

  const year = date.getFullYear();

  const month = String(date.getMonth() + 1).padStart(2, "0");

  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

function PerfomanceAllocationList() {
  const navigate = useNavigate();
  const [allocations, setAllocations] = useState([]);
  const [loading, setLoading] = useState(false);

  const currentdate = new Date();

  const currentYear = currentdate.getFullYear();
  const currentMonth = currentdate.getMonth() + 1;
  const currentday = currentdate.getDate();

  const [filters, setFilters] = useState({
    search: "",
    date: getToday(),
    day: currentday,
    yearName: currentYear,
    monthName: currentMonth,
    vertical: "",
    priority: "",
    hiring_type: "",
    working_mode: "",
    status: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [date, setDate] = useState(getToday());

  const SERVER_URL = process.env.REACT_APP_API_URL;
  const BASE_URL = process.env.REACT_APP_APP_URL;

  const token = JSON.parse(localStorage.getItem("key"));

  const tokenDecoded = jwt_decode(token.value);
  // console.log(tokenDecoded, "tokenDecoded========");
  const systemRole = tokenDecoded.systemRole ?? "";
  const userID = tokenDecoded.userId ?? "";

  useEffect(() => {
    loadAllocations();
  }, [
    date,
    currentPage,
    recordsPerPage,
    filters.day,
    filters.search,
    filters.monthName,
    filters.yearName,
  ]);

  const loadAllocations = async () => {
    try {
      setLoading(true);

      const params = new URLSearchParams();

      // Pagination
      params.append("role", systemRole);
      params.append("user_id", userID);
      params.append("page", currentPage);
      params.append("pageSize", recordsPerPage);
      params.append("date", date);
      params.append("day", filters.day);
      params.append("month", filters.monthName);
      params.append("year", filters.yearName);

      // Filters
      if (filters.search) {
        params.append("search", filters.search);
      }

      const apiUrl = `${SERVER_URL}api/Performance/allocation/all?${params.toString()}`;

      console.log("REQUEST Allocation API:", apiUrl);

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.value}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      console.log(result.total.data, "allocations===========");

      setAllocations(result.data.data || []);
      setTotalRecords(Number(result.total.data || 0));
    } catch (error) {
      console.error("Allocation loading error:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Always go back to page 1
    setCurrentPage(1);
  };
  const clearFilters = () => {
    setFilters({
      search: "",
      date: getToday(),
      day: currentday,
      yearName: currentYear,
      monthName: currentMonth,
      vertical: "",
      priority: "",
      hiring_type: "",
      working_mode: "",
      status: "",
    });

    setCurrentPage(1);
  };

  const totalPages = Math.ceil(totalRecords / recordsPerPage);
  const startIndex =
    totalRecords === 0 ? 0 : (currentPage - 1) * recordsPerPage;

  const endIndex = Math.min(currentPage * recordsPerPage, totalRecords);
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      setCurrentPage(page);
    }
  };
  const getPageNumbers = () => {
    const pages = [];

    // No pages
    if (totalPages <= 0) {
      return pages;
    }

    // 1 - 5 pages
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }

      return pages;
    }

    // Current page near beginning
    if (currentPage <= 3) {
      pages.push(1, 2, 3, 4, "...", totalPages);

      return pages;
    }

    // Current page near end
    if (currentPage >= totalPages - 2) {
      pages.push(
        1,
        "...",
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      );

      return pages;
    }

    // Current page in middle
    pages.push(
      1,
      "...",
      currentPage - 1,
      currentPage,
      currentPage + 1,
      "...",
      totalPages,
    );

    return pages;
  };
  //   const filteredAllocations = allocations.filter((item) => {
  //     const text = `
  //                 ${item.employee_name}
  //                 ${item.manager_name}
  //                 ${item.department_name}
  //                 ${item.task_name}
  //                 ${item.stage_name}
  //             `.toLowerCase();

  //     return text.includes(filters.search.toLowerCase());
  //   });

  const handleView = (id) => {
    window.location.href = `Performance/allocation/view/${id}`;
  };

  const handleEdit = (id) => {
    window.location.href = `Performance/allocation/edit/${id}`;
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this allocation?",
    );

    if (!confirmDelete) {
      return;
    }

    try {
      await axios.delete(`${API_URL}Performance/allocation/${id}`);

      loadAllocations();
    } catch (error) {
      console.error("Delete allocation error:", error);

      alert("Unable to delete allocation");
    }
  };

  return (
    <>
      <div className="page-header">
        <h3>
          Production Performance List
          <div>
            {/* <button
              className="btn_5 mr10 float-end"
              onClick={() =>
                (window.location.href = "Performance/allocation/create")
              }
            >
              + Allocation
            </button> */}
          </div>
        </h3>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <a href="/dashboard">Dashboard </a>
          </li>
          <li className="current">
            <span>/</span> Employee
          </li>
        </ul>
      </div>
      {/* Search */}

      <div className="row_bg">
        <div className="dash_white_box2 mb20 p20">
          <div className="row mb10">
            <div className="col-lg-3 col-md-6 pr07">
              <label className="form-label">Search</label>
              <input
                type="text"
                className="form-control"
                name="search"
                placeholder="Employee, manager, department, task..."
                value={filters.search}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    search: e.target.value,
                  })
                }
              />
            </div>
            <div className="col-lg-3 col-md-6 pl07 pr07">
              <label className="form-label">Month</label>
              <select
                className="form-control"
                value={filters.monthName}
                name="monthName"
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    monthName: e.target.value,
                  })
                }
              >
                <option value="">--Select Month--</option>
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </select>
            </div>
            <div className="col-lg-3 col-md-6 pl07 pr07">
              <label className="form-label">Year</label>
              <select
                className="form-control"
                value={filters.yearName}
                name="yearName"
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    yearName: e.target.value,
                  })
                }
              >
                <option value="">--Select Year--</option>
                <option value="2026">2026</option>
                <option value="2027">2027</option>
                <option value="2028">2028</option>
              </select>
            </div>
            {/* <div className="col-lg-3 col-md-6 pr07">
              <label className="form-label">Review Date</label>
              <input
                type="text"
                className="form-control"
                value={filters.date}
                onChange={handleFilterChange}
                autoComplete="none"
                placeholder="Search by Date"
              />
              
            </div> */}

            <div className="col-lg-3 col-md-6 pl07 pr07">
              <label className="d-block mb30 pt07"></label>
              <button className="btn_6" onClick={clearFilters}>
                Clear Filters
              </button>
            </div>
          </div>
        </div>
        <div className="row mb30">
          <div className="col-md-12">
            <strong>All Production Allocations</strong>

            <span className="float-end">{totalRecords} Records</span>
          </div>

          <div
            className="col-md-12"
            style={{
              width: "100%",
              overflowX: "auto",
              overflowY: "hidden",
            }}
          >
            <table
              className="table_style_1"
              style={{
                minWidth: "1200px",
                whiteSpace: "nowrap",
              }}
            >
              <thead className="table-primary">
                <tr>
                  <th>S.No</th>
                  <th>Employee Name</th>
                  {/* <th>Manager Name</th>
                  <th>Department</th>
                  <th>Task Name</th>
                  <th>Stage Name</th> */}
                  <th>Alloc month</th>
                  <th>Total Alloc./Comp. Pages</th>
                  <th>Total Alloc./Comp. Hrs</th>
                  <th>Page Score %</th>
                  <th>Hours Score %</th>
                  <th>Allocation Score %</th>
                  <th>KPI Score</th>
                  <th>Daily Score</th>
                  <th>Final</th>
                  <th>Rating</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="9" className="text-center">
                      Loading...
                    </td>
                  </tr>
                ) : allocations.length === 0 ? (
                  <tr>
                    <td colSpan="9" className="text-center">
                      No allocation found
                    </td>
                  </tr>
                ) : (
                  allocations.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>

                      <td>
                        <strong>{item.employee_name}</strong>
                      </td>

                      {/* <td>{item.manager_name || "-"}</td>

                      <td>{item.department_name || "-"}</td>

                      <td>
                        {item.task_name?.length > 30
                          ? item.task_name.substring(0, 30) + "..."
                          : item.task_name}
                      </td>

                      <td>{item.stage_name}</td> */}
                      <td>
                        {item.allocation_type === 1
                          ? item.task_start_date
                            ? item.month_name
                            : "-"
                          : item.allocation_type === 2
                            ? item.month_name
                            : "-"}
                      </td>
                      <td>
                        {item.allocated_pages}/{item.completed_pages}
                      </td>

                      <td>
                        {item.allocated_hours}/{item.completed_hours} Hrs.
                      </td>

                      <td>
                        <span className="badge bg-info">
                          {item.page_completion_percentage}%
                        </span>
                      </td>

                      <td>
                        <span
                          className={`badge ${
                            item.performance_percentage >= 80
                              ? "bg-success"
                              : item.performance_percentage >= 60
                                ? "bg-warning"
                                : "bg-danger"
                          }`}
                        >
                          {item.hour_completion_percentage}%
                        </span>
                      </td>
                      <td>
                        {" "}
                        {item.allocation_score ? item.allocation_score : "0.00"}
                        %
                      </td>
                      <td>
                        <span
                          className={`badge ${
                            item.final_score >= 80
                              ? "bg-success"
                              : item.final_score >= 60
                                ? "bg-warning"
                                : "bg-danger"
                          }`}
                        >
                          {item.kpi_score ? item.kpi_score : "0.00"}%
                        </span>
                      </td>
                      <td>
                        <span
                          className={`badge ${
                            item.final_score >= 80
                              ? "bg-success"
                              : item.final_score >= 60
                                ? "bg-warning"
                                : "bg-danger"
                          }`}
                        >
                          {item.daily_score ? item.daily_score : "0.00"}%
                        </span>
                      </td>
                      <td>
                        <span
                          className={`badge ${
                            item.final_score >= 80
                              ? "bg-success"
                              : item.final_score >= 60
                                ? "bg-warning"
                                : "bg-danger"
                          }`}
                        >
                          {item.final_score ? item.final_score : "0.00"}%
                        </span>
                      </td>
                      <td>{item.manager_rating ? item.manager_rating : "0"}</td>
                      <td>
                        {item.review_status === "Approved" ? (
                          <span className="badge bg-success">Approved</span>
                        ) : item.review_status === "Rejected" ? (
                          <span className="badge bg-danger">Rejected</span>
                        ) : (
                          <span className="badge bg-warning">Pending</span>
                        )}
                      </td>

                      <td>
                        <div className="d-flex gap-1">
                          {/* View */}

                          {/* <button
                            className="btn btn-sm btn-info"
                            title="KPI"
                            onClick={() => handleView(item.id)}
                          >
                            KPI
                          </button> */}
                          <Link
                            className="btn btn-sm btn-info"
                            to={`/manager/performance-review/${item.employee_id}/${filters.day}/${filters.monthName}/${filters.yearName}/${date}`}
                          >
                            Review
                          </Link>

                          {/* Edit */}

                          {/* <button
                            className="btn btn-sm btn-warning"
                            title="Edit"
                            onClick={() => handleEdit(item.id)}
                          >
                            ✏️
                          </button> */}
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          {/* =================================================
              PAGINATION
          ================================================= */}

          {totalRecords > 0 && (
            <div className="pagination-wrapper">
              {/* Pagination Info */}
              <div className="pagination-info">
                Showing <strong>{startIndex + 1}</strong> to{" "}
                <strong>{endIndex}</strong> of <strong>{totalRecords}</strong>{" "}
                entries
              </div>

              {/* Pagination */}
              <div className="pagination">
                {/* Previous */}
                <button
                  disabled={currentPage === 1 || loading}
                  onClick={() => goToPage(currentPage - 1)}
                >
                  <i className="bi bi-chevron-left">«</i>
                </button>

                {/* Page Numbers */}
                {getPageNumbers().map((page, index) => {
                  if (page === "...") {
                    return (
                      <span key={`dots-${index}`} className="pagination-dots">
                        ...
                      </span>
                    );
                  }

                  return (
                    <button
                      key={page}
                      disabled={loading}
                      className={currentPage === page ? "active" : ""}
                      onClick={() => goToPage(page)}
                    >
                      {page}
                    </button>
                  );
                })}

                {/* Next */}
                <button
                  disabled={currentPage === totalPages || loading}
                  onClick={() => goToPage(currentPage + 1)}
                >
                  <i className="bi bi-chevron-right">»</i>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
export default PerfomanceAllocationList;
